import Vue from 'vue';
import { Consoler } from './Consoler';
import { Settings } from '@/models/settings';

class ConfigDefinition extends Vue {
  public Settings: Settings = {
    ApiBaseUrl: '',
    FullConsole: 'false'
  };

  public readonly GisServicesMapLayer: string =
    process.env.VUE_APP_GIS_SERVICES_MAP_LAYER;
  public readonly GisServicesServicesUrl: string =
    process.env.VUE_APP_GIS_SERVICES_SERVICES_URL;
  public readonly DefaultMapCoordsLat: number = Number(
    process.env.VUE_APP_DEFAULT_MAP_COORDS_LAT
  );
  public readonly DefaultMapCoordsLng: number = Number(
    process.env.VUE_APP_DEFAULT_MAP_COORDS_LNG
  );
  public readonly DefaultMapZoom: number = Number(
    process.env.VUE_APP_DEFAULT_MAP_ZOOM
  );

  public readonly MapSetPointsEvent: string = 'mapSetPoints';
  public readonly MapSetFullScreenEvent: string = 'mapSetFullScreen';
  public readonly MapSetShowSidebarRightEvent: string =
    'mapSetShowSidebarRight';
  public readonly MapPointSelectedEvent: string = 'mapPointSelected';
  public readonly MapClearSelectedPointsEvent: string =
    'mapClearSelectedPoints';

  public SetSettings(settings: Settings) {
    Consoler.debugLog('Setting settings:', settings);
    this.Settings = settings;
  }
}

export const Config = new ConfigDefinition();
